import { render, staticRenderFns } from "./precanned.vue?vue&type=template&id=3ecd8c54&"
import script from "./precanned.vue?vue&type=script&lang=js&"
export * from "./precanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BetbuilderPrecannedLine: require('/var/web/bet777.es/components/betbuilder/precanned_line.vue').default})
